define.alias("shared/components/shared/post-tagging/color-circle", "preview-grid/components/shared/post-tagging/color-circle");